{
    "NavigationNext": "Suivant",
    "NavigationPrevious": "Précédent",
    "ApplicationUservoice": "https:\/\/akixi.uservoice.com",
    "ApplicationDefaultDirectory": "\/CCS\/Styles\/Images\/Akixi2019\/",
    "NAME": "LanguageGeneral"
}